module.exports = __webpack_public_path__ + "img/xingxing.282cefbc.png";